import { render, staticRenderFns } from "./RenShi5.vue?vue&type=template&id=8644d590&scoped=true&"
import script from "./RenShi5.vue?vue&type=script&lang=js&"
export * from "./RenShi5.vue?vue&type=script&lang=js&"
import style0 from "./RenShi5.vue?vue&type=style&index=0&id=8644d590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8644d590",
  null
  
)

export default component.exports